import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import api from '../api/client'
import type { Card, SharedCourse, SharedDeck } from '../types'

export function useSharedDeck(token: string) {
  return useQuery({
    queryKey: ['shared', 'deck', token],
    queryFn: async () => {
      const { data } = await api.get<SharedDeck>(`/api/v1/shared/deck/${token}`)
      return data
    },
    enabled: !!token,
    retry: false,
  })
}

export function useSharedCourse(token: string) {
  return useQuery({
    queryKey: ['shared', 'course', token],
    queryFn: async () => {
      const { data } = await api.get<SharedCourse>(`/api/v1/shared/course/${token}`)
      return data
    },
    enabled: !!token,
    retry: false,
  })
}

export function useSharedCard(token: string) {
  return useQuery({
    queryKey: ['shared', 'card', token],
    queryFn: async () => {
      const { data } = await api.get<Card>(`/api/v1/shared/card/${token}`)
      return data
    },
    enabled: !!token,
    retry: false,
  })
}

export interface ImportCardResult {
  card_id: string
  deck_id: string
  created: boolean
}

export function useImportCard() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async ({ shareToken, targetDeckId }: { shareToken: string; targetDeckId: string }) => {
      const { data } = await api.post<ImportCardResult>('/api/v1/cards/import', {
        share_token: shareToken,
        target_deck_id: targetDeckId,
      })
      return { ...data, targetDeckId }
    },
    onSuccess: ({ targetDeckId }) => {
      qc.invalidateQueries({ queryKey: ['cards', targetDeckId] })
      qc.invalidateQueries({ queryKey: ['deck', targetDeckId] })
      qc.invalidateQueries({ queryKey: ['decks'] })
    },
  })
}
